import { Container } from '@mui/material';
import React from 'react';
import { ScrollRestoration, useLoaderData } from 'react-router-dom';
import AppBar from '../app-bar/AppBar';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import MdViewer from '../markdown/MdViewer';

const Privacy = () => {
  const privacy = useLoaderData() as string;

  return (
    <>
      <AppBar title="Privacy" />
      <Breadcrumbs
        items={[{ label: 'Home', to: '/' }, { label: 'Profile', to: '/profile' }, { label: 'Privacy' }]}
        sx={{ display: { xs: 'none', sm: 'flex' } }}
      />
      <ScrollRestoration />
      <Container sx={{ my: 4 }}>
        <MdViewer text={privacy}></MdViewer>
      </Container>
    </>
  );
};

export default Privacy;
